<template>
  <div class="area-selection">
    <section-title has-line title="Seleccionar Área Académica" />
    <div class="d-flex flex-row justify-content-between align-items-start">
      <div class="col-5 pr-3 border-right">
        <label class="d-block mb-2">Áreas del PEI:</label>
        <validation-provider
          ref="areaValidator"
          v-slot="{ errors }"
          name="customDropDownArea"
        >
          <custom-drop-down
            id="area"
            v-model="model.area"
            :clearable="false"
            custom-error-msg="Favor seleccionar un área."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            :options="availableAreaOptions"
            placeholder="Seleccione"
          />
        </validation-provider>

        <div class="row mt-3 mr-1 d-flex justify-content-end">
          <action-button
            id="btnAdd"
            i="fas fa-file-plus fa-lg"
            text="Añadir"
            variant="success"
            @click="onAddHandler"
          />
        </div>
      </div>

      <div class="col-7 pl-3">
        <label class="d-block mb-2">
          Áreas Seleccionadas:
        </label>
        <div class="py-2 px-1">
          <div>
            <div
              v-for="(item, index) in localSelected"
              :key="`reason-item-${index}`"
              class="reason-item px-3 py-1 d-inline-block mr-2 my-2"
            >
              <span class="color-black font-16 font-weight-bold">
                {{ item.name }}
              </span>
              <i
                class="far fa-times-circle text-red font-16 cursor-pointer ml-2"
                @click="onDeleteItemHandler(index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import SectionTitle from 'SectionTitle';

export default {
  name: 'AreaSelection',
  components: {
    CustomDropDown,
    ActionButton,
    SectionTitle,
  },
  props: {
    areaOptions: {
      type: Array,
      default: () => [],
    },
    selectedAreas: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    model: {
      area: null,
    },
    localSelected: [],
  }),
  computed: {
    availableAreaOptions() {
      return this.areaOptions.filter((x) => !this.addedAreasIds.includes(x.id));
    },
    addedAreasIds() {
      return this.localSelected.map((x) => x.id);
    },
  },
  watch: {
    selectedAreas(newVal) {
      this.localSelected = [...newVal];
    },
  },
  created() {
    if (this.selectedAreas && this.selectedAreas.length) {
      this.localSelected = [...this.selectedAreas];
    }
  },
  methods: {
    onAddHandler() {
      if (this.model.area) {
        this.localSelected.push(this.model.area);
        this.model.area = null;
        this.$refs.areaValidator.setErrors([]);
        this.$emit('save-area-selection', [...this.localSelected]);
      } else {
        this.$refs.areaValidator.setErrors(['Favor seleccionar un área.']);
      }
    },
    onDeleteItemHandler(index) {
      this.localSelected.splice(index, 1);
      this.$emit('save-area-selection', [...this.localSelected]);
    },
  },
};
</script>

<style scoped lang="scss">
.reason-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
  font-size: 90%;
}
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
